import { useApplicationStore } from '@/models/application-store';

import type { Replay } from '@/shared/model/types/replay';

import { deleteReplay as reqDeleteReplay } from '../api';
import { ERROR_MAP } from '../config';
import type { ReplayRequest } from './types';

const deleteReplay = async (id: Replay['id']): Promise<ReplayRequest> => {
  const store = useApplicationStore();
  const { dialogs } = storeToRefs(store);

  try {
    dialogs.value.deleteReplay.isRequest = true;
    return await reqDeleteReplay(id);
  } catch (error) {
    console.error('Error deleting replay:', error);
  } finally {
    dialogs.value.deleteReplay.isRequest = false;
  }

  return ERROR_MAP.get('network') ?? { status: false };
};

export { deleteReplay, ERROR_MAP };
